import deviceThumbnail from '../assets/pos-5-thumbnail.webp';

const DeviceThumbnail = () => (
	<div className='flex items-center justify-center w-14 h-14 p-1 bg-secondary-ultra-light rounded-lg'>
		<img
			src={deviceThumbnail}
			alt=''
			aria-hidden='true'
			className='w-11 h-11 object-contain'
		/>
	</div>
);

export default DeviceThumbnail;
